import { ITempPlannedPortfoliosState } from '../../state/temp-planned-portfolios.state';
import { createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IPlannedPortfoliosState } from '../../state/planned-portfolios.state';
import { IAppState } from '../../state/app.state';
import { getPlannedPortfoliosState } from './planned-portfolios.selectors';

export const getTempPlannedPortfoliosState = createFeatureSelector<IAppState, ITempPlannedPortfoliosState>('tempPlannedPortfolios');

export const getSelectedTempPlannedportfolio = createSelector(
  getTempPlannedPortfoliosState,
  (state) => {
    return state.entities[state.selectedSubscriptionId];
  }
);
export const getSelectedTempPlannedIds = createSelector(
  getTempPlannedPortfoliosState,
  (state) => {
    return state.ids;
  }
);
export const tempPlannedPortfolioAdapter = createEntityAdapter<IPlannedPortfolio>({
  selectId: (tempPlannedPortfolio: IPlannedPortfolio) => tempPlannedPortfolio.subscriptionId
});
export const selectLoadingPlannedPortfolio = createSelector(
  getPlannedPortfoliosState,
  (state: IPlannedPortfoliosState) => state.loading
);
export const selectTempLoadingPlannedPortfolio = createSelector(
  getTempPlannedPortfoliosState,
  (state: ITempPlannedPortfoliosState) => state.loading
);
export const {
  selectAll: selectAllTempPlannedPortfolios,
  selectEntities: selectTempPlannedPortfolios
} = tempPlannedPortfolioAdapter.getSelectors(getTempPlannedPortfoliosState);

export const selectPlannedPortfolioDataError = createSelector(
  getPlannedPortfoliosState,
  (state: IPlannedPortfoliosState) => state.plannedPortfolioDataError
);
